import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService, Partner } from './data.service';
import { DeviceDetectService } from './device-detect.service';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {
  constructor(
    private dataService: DataService,
    private deviceDetectService: DeviceDetectService
  ) {}

  getPartners(): Observable<Partner[]> {
    return this.dataService.getData().pipe(
      map(data => {
        const isMobile = this.deviceDetectService.getIsMobile();
        let partners = data.partners || [];
        
        // Filter partners based on device
        if (!isMobile) {
          // Desktop: show only non-mobile partners
          partners = partners.filter(p => !p.isMobile);
        }
        // Mobile: show all partners (no filter)
        
        // Sort by order
        return partners.sort((a, b) => a.order - b.order);
      })
    );
  }
}

